import { useState, useCallback } from 'react';

const useLoadingManager = () => {
    const [loadingStates, setLoadingStates] = useState({
        map: true,
        location: false,
        route: false,
        permissions: true
    });

    const updateLoadingState = useCallback((key, value) => {
        setLoadingStates(prev => ({ ...prev, [key]: value }));
    }, []);

    const isAnyLoading = Object.values(loadingStates).some(state => state);

    return {
        loadingStates,
        updateLoadingState,
        isAnyLoading
    };
};

export default useLoadingManager; 